
<!-- HIDDEN INPUT TYPE FILE -->
<input type="file"
       class="td-wb-file-upload--hidden"
       [name]="name()"
       [accept]="accept()"
       (change)="onFileSelected($event)"
       #fileUpload>

<div class="td-wb-file-upload"
     id="td-wb-file-upload-area"
     [ngClass]="{
      'td-wb-file-upload--dotted': !native && allowsDragDrop(),
      'td-wb-file-upload--dragging': isDragging(),
      'td-wb-file-upload--disabled': disabled()
    }">

  <div class="td-wb-file-upload--dragging__first"
       [ngClass]="{
          'td-wb-file-upload--hidden': !isDraggingFirst(),
          'td-wb-file-upload--dragging__first': isDraggingFirst() }">
    <span class="td-wb-file-upload--dragging__msg"
          translate="tdWb.fileUpload.DROP"></span>
  </div>

  <!-- INSTRUCTIONAL COPY AND SELECT BUTTON -->
  <div class="td-wb-file-upload__message">
    <!-- PLEASE SELECT MESSAGE: content projection OR default message when empty -->
     <ng-content select=".td-wb-file-upload__message" />
     <span class="td-wb-file-upload__message--default" translate="tdWb.fileUpload.SELECT"></span>

    <!-- SELECT FILE BUTTON -->
    <button tdWbButton
            tdWbButtonType="secondary"
            tdWbButtonSize="small"
            [disabled]="disabled()"
            (click)="onBrowseFileButtonClick()"
            [attr.aria-describedby]="'tdWb.fileUpload.SELECT'|translate"
            #browseButton>
      <span translate="tdWb.fileUpload.BROWSE"></span>
    </button>
  </div>

  <!-- LIST OF FILES SELECTED -->
  <div aria-live="polite"
       role="list"
       [attr.aria-label]="'tdWb.fileUpload.COUNT_MANY' | translate">
    @if (value?.length > 0) {
    <div class="td-wb-file-upload__divider"></div>
    }
    @for (file of value; track file) {
    <div class="td-wb-file-upload__file" role="listitem">
      <td-wb-icon iconId="check-mark--small"
                  iconType="primary">
      </td-wb-icon>
      <span [innerText]="file.fileName"></span>
      <button class="td-wb-file-upload-button__icon"
              tdWbIconButton
              tdWbIconButtonSize="extra-small"
              tdWbIconButtonBackground="clear-grey"
              role="button"
              [disabled]="disabled()"
              [attr.aria-label]="'tdWb.fileUpload.REMOVE' | translate : { filename: file.fileName }"
              (click)="remove(confirmTemplate, file, $event)"
              (keypress)="remove(confirmTemplate, file, $event)">
        <td-wb-icon iconId="close--small"
                    class="td-wb-file-upload__remove"
                    size="12" />
      </button>
    </div>
    }
  </div>
</div>

<!-- CONTENT PROJECTION OF COUNTER ELEMENT -->
<ng-content select="td-wb-file-upload-counter" />

<!-- CONFIRM COMPONENT -->
<ng-template #confirmTemplate>
  <td-wb-confirm>
    <td-wb-confirm-title><span translate="tdWb.fileUpload.confirm.TITLE"></span></td-wb-confirm-title>
    <td-wb-confirm-body class="td-wb-file-upload__delete">
      <span translate="tdWb.fileUpload.confirm.BODY"
            [translateParams]="{filename: fileToDelete}"
            class="td-wb-file-upload__delete--body"></span>
    </td-wb-confirm-body>
    <td-wb-confirm-buttons>
      <td-wb-confirm-button-cancel (click)="onConfirmationClose()" />
      <td-wb-confirm-button-ok />
    </td-wb-confirm-buttons>
  </td-wb-confirm>
</ng-template>
